// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"b72b8342","870":"e4fe2624"}[chunkId] + ".chunk.css";
};